import React from 'react'
import MainNavigation from './MainNavigation'
import Tier2NavBar from './Tier2NavBar'
import { color } from '../../style/variables'
import { useNavHeader } from '../../context/NavHeaderProvider'

export const Navigation = () => {
  const { isTierTwoMenuVisible } = useNavHeader()

  return (
    <>
      <style jsx>
        {`
          .second-level-nav {
            background-color: ${color.white};
          }
        `}
      </style>
      <MainNavigation />
      {isTierTwoMenuVisible && (
        <div className="second-level-nav">
          <Tier2NavBar />
        </div>
      )}
    </>
  )
}
